/**
 * Pure classifiers for the fan ordering-funnel telemetry (PostHog events sent
 * from TagPage). Kept free of React and Supabase so they can be unit-tested.
 */

/** Why create-payment-intent refused a Pay tap. */
export type RefusalReason = 'paused' | 'online_payment_not_ready' | 'item_not_for_tenant' | 'pickup_only_items' | 'addon_choice_required' | 'other';

/**
 * Why create-payment-intent refused a Pay tap, from the message + body text
 * TagPage already assembles (`${err.message} ${body.code} ${body.error}`,
 * lower-cased).
 */
export function refusalReason(msg: string): RefusalReason {
  if (msg.includes('ordering_paused') || msg.includes('temporarily paused')) return 'paused';
  if (msg.includes('online payment is not available') || msg.includes('business info') || msg.includes('stripe_not_ready')) {
    return 'online_payment_not_ready';
  }
  if (msg.includes('item_not_for_tenant')) return 'item_not_for_tenant';
  if (msg.includes('addon_choice_required')) return 'addon_choice_required';
  // The server's pick-up-only refusal carries code 'delivery_item_not_allowed'
  // (and lists the items in pickup_only_items, which is not part of msg).
  if (msg.includes('pickup_only') || msg.includes('delivery_item_not_allowed')) return 'pickup_only_items';
  return 'other';
}

/** How a payment redirect (MobilePay / 3-D Secure) came back to the fan page. */
export type PaymentReturnOutcome = 'succeeded' | 'failed' | 'processing' | 'unknown';

/** Stripe's `redirect_status` query param, narrowed to the outcomes we report. */
export function paymentReturnOutcome(redirectStatus: string | null): PaymentReturnOutcome {
  if (redirectStatus === 'succeeded' || redirectStatus === 'failed' || redirectStatus === 'processing') {
    return redirectStatus;
  }
  return 'unknown';
}
